import { fetchDataSources } from '@/composables/segmentations/helpers/fetchData';

/**
 * Boutique « multi-sources » : plus d'une source de données active. Règle
 * unique, celle du sélecteur de points de vente du header, reprise par le
 * catalogue des widgets, les filtres de page et l'affichage des widgets
 * réservés à ces boutiques.
 */
export const isMultiSourceShop = (activeSources: ReadonlyArray<unknown>): boolean => activeSources.length > 1;

/** Même règle, sur les sources actives de la boutique (cache partagé de `fetchDataSources`). */
export const fetchIsMultiSourceShop = async (): Promise<boolean> => isMultiSourceShop(await fetchDataSources());

/** Widgets qui n'ont de sens qu'avec plusieurs points de vente (`groupe.catégorie.métrique`). */
export const MULTI_SOURCE_ONLY_METRICS = ['general.orders.income-of-orders-by-source'];

interface MetricReference {
  group?: string;
  category?: string;
  metric?: string;
}

export const isMultiSourceOnlyMetric = (metric: MetricReference | null | undefined): boolean => !!metric
  && MULTI_SOURCE_ONLY_METRICS.includes(`${metric.group}.${metric.category}.${metric.metric}`);

/** Un widget réservé aux boutiques multi-sources n'est proposé et affiché qu'à elles. */
export const isMetricAvailableForShop = (
  metric: MetricReference | null | undefined,
  multiSource: boolean,
): boolean => multiSource || !isMultiSourceOnlyMetric(metric);
